export default __webpack_public_path__ + "static/media/calendar.2e878fe1.svg";